import React from "react";

const MenuToggle = (props) => {
  return (
    <div {...props}>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 100 125"
          enableBackground="new 0 0 100 100"
        >
          <path d="M7.12,24.341h85.759c1.171,0,2.121-0.949,2.121-2.121s-0.95-2.12-2.121-2.12H7.12 C5.949,20.1,5,21.049,5,22.22S5.949,24.341,7.12,24.341z"></path>
          <path d="M92.879,46.149H7.12C5.949,46.149,5,47.099,5,48.27s0.949,2.12,2.12,2.12h85.759 c1.171,0,2.121-0.949,2.121-2.12S94.05,46.149,92.879,46.149z"></path>
          <path d="M92.879,72.2H7.12C5.949,72.2,5,73.149,5,74.32s0.949,2.12,2.12,2.12h85.759c1.171,0,2.121-0.949,2.121-2.12 S94.05,72.2,92.879,72.2z"></path>
        </svg>
      </div>
    </div>
  );
};

export default MenuToggle;



// WEBPACK FOOTER //
// ./src/components/common/menuToggle.js